import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'login-state',
  storage: typeof window === 'undefined' ? undefined : sessionStorage,
});

export const isLoggedInAtom = atom({
  key: 'isLoggedInAtom',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
